import Swiper, {
  Navigation,
  A11y,
  EffectFlip
} from 'swiper/core';
Swiper.use([Navigation, A11y, EffectFlip]);

var flippy_tiles = document.getElementsByClassName("swiper-flippy-tile");
Array.from(flippy_tiles).forEach((element) => {
  var id = element.dataset.id ?? 1;
  var swiperConfig = {
    direction: 'horizontal',
    effect: 'flip',
    slidesPerView: 1,
    spaceBetween: 30,
    mousewheel: true,
    navigation: {
      nextEl: ".flippy-tile-first-side-" + id,
      prevEl: ".flippy-tile-second-side-" + id,
    },
  }
  new Swiper(element, swiperConfig);

});